<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.description') }}</label></td>
      <td>{{ details.description }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.createdBy') }}</label></td>
      <td>{{ details.created_by }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updatedBy') }}</label></td>
      <td>{{ details.modified_by }}</td>
    </tr>
  </table>
</template>
<script>
export default {
  name: 'ptScheduleDetails',
  components: {},
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  computed: {}
};
</script>
<style></style>
